/**
 * Component to display main content of the app.
 *
 * Displays nothing if the theme and list of flowsheets is not yet loaded
 * -- this avoids adding conditional rendering logic to the App component.
 */
import './MainContent.css';
import {Container} from "@mui/material";
import Navigation from "../Navigation/Navigation";
import {Navigate, Route, Routes} from "react-router-dom";
import FlowsheetConfig from "../../views/FlowsheetConfig/FlowsheetConfig";
import FlowsheetsList from "../../views/FlowsheetsList/FlowsheetsList";
import React from "react";
import LandingPage from "../../views/LandingPage";

export default function MainContent(props) {
    console.debug("MainContent: props=", props);
    if (props.connectedToBackend) {
        const theme = props.theme;
        const spState = props.subProcState;
        return (
            <Container id='AppRootContainer' sx={{ pt: 8 }}>
                <Navigation />
                <Routes>
                    <Route path="/" element={<LandingPage/>}/>
                    <Route
                        path="flowsheet/:id/config"
                        element={
                            <FlowsheetConfig
                                numberOfSubprocesses={spState.value}
                                setNumberOfSubprocesses={spState.setValue}
                                theme={theme}
                            />
                        }
                    />
                    <Route
                        path="flowsheets"
                        element={
                            <FlowsheetsList
                                setNumberOfSubprocesses={spState.setValue}
                                theme={theme}
                            />
                        }
                    />
                    <Route
                        path="*"
                        element={<Navigate replace to="flowsheets"/>}
                    />
                </Routes>
            </Container>
        );
    }
    else {
        return null;
    }
}
